import { searchRegistry } from "../../platform/search/register/search-registry";
import { CalendarDays, PartyPopper,Image } from "lucide-react";


searchRegistry.register([
    {
        id: "highlights.events",
        title: "Culture & Events",
        description: "Manage Culture & Events",
        route: "/highlights/our-events",
        category: "Administration",
        permissions: ["ADMIN","EMPLOYEE","USER"],
        tags: ["events", "sessions","culture"],
        icon: CalendarDays,
        type: 'result'
    },
    {
        id: "highlights.celebration",
        title: "Culture & Events",
        description: "Manage Culture & Events",
        route: "/highlights/celebrations",
        category: "Administration",
        permissions: ["ADMIN","EMPLOYEE","USER"],
        tags: ["wish", "birthday","anniversary","celebration"],
        icon: PartyPopper,
        type: 'result'
    },
    {
        id: "highlights.media.hub",
        title: "Moments & Media",
        description: "View Moments & Media",
        route: "/highlights/media-hub",
        category: "Administration",
        permissions: ["ADMIN","EMPLOYEE","USER"],
        tags: ["media", "photos"],
        icon: Image,
        type: 'result'
    }
])
